import React from 'react';
import { Steps } from 'antd';
import {
  FileTextOutlined,
  UserAddOutlined,
  FormOutlined,
  SendOutlined,
} from '@ant-design/icons';

const steps = [
  {
    title: 'General',
    description: 'Document info',
    icon: <FileTextOutlined />,
  },
  {
    title: 'Add Signers',
    description: 'Recipients',
    icon: <UserAddOutlined />,
  },
  {
    title: 'Add Fields',
    description: 'Place fields',
    icon: <FormOutlined />,
  },
  {
    title: 'Distribution',
    description: 'Send for signing',
    icon: <SendOutlined />,
  },
];

const Stepper = ({ currentStep }) => {
  return (
    <Steps
      current={currentStep - 1}
      items={steps.map((step, index) => ({
        title: step.title,
        description: step.description,
        icon: step.icon,
        status: index < currentStep - 1 ? 'finish' : index === currentStep - 1 ? 'process' : 'wait',
      }))}
      style={{ maxWidth: 800, margin: '0 auto' }}
    />
  );
};

export default Stepper;
